export default "__VITE_ASSET__1LDVAdIu__"